import { createSlice } from "@reduxjs/toolkit";

// Initial state structure for selectedContentAI
const initialState = {};

const selectedContentAISlice = createSlice({
  name: "selectedContentAI",
  initialState,
  reducers: {
    setSelectedContentAI: (state, action) => {
      const { contentAI } = action.payload;

      return {
        ...contentAI,
      };
    },

    clearSelectedContentAI: (state) => {
      return {};
    },
  },
});

export const { setSelectedContentAI, clearSelectedContentAI } =
  selectedContentAISlice.actions;

export default selectedContentAISlice.reducer;
